module.exports = "/_next/static/images/va-d76a4c0a9d11e9d29aae93d9972e913a.svg";